import { useState } from 'react'
import { useConfig } from 'builder/hooks/useConfig'
import { useUser } from 'builder/hooks/useUser'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'
import SubscriptionCancellationViewOld from '../SubscriptionCancellationViewOld'
import { SubscriptionCancellationViewStepOne } from './StepOne'
import { SubscriptionCancellationViewStepThree } from './StepThree'
import { SubscriptionCancellationResumeDistribution } from './ResumeDistribution'
import { SubscriptionCancellationResumeDistributionDisabled } from './ResumeDistributionDisabled'

export const SubscriptionCancellationView = () => {
  const [step, setStep] = useState(1)
  const config = useConfig()
  const featuresConfig = useFeaturesConfig()
  const isSubscriptionV4Enabled = config?.features.subCancellationV4 || false
  const { host } = window.location
  const isHostRioCio =
    host === 'staging.resume.io' ||
    host === 'resume.io' ||
    host === 'career.io' ||
    host === 'staging.career.io' ||
    host.includes('localhost')
  const user = useUser()
  const hasResumeDistribution = !!user?.scopes?.resumeDistributionCandidate
  const isRDSubCancellationTestEnabled = config?.features.rdInSubCancellation
  const canActivateRd = featuresConfig.showResumeDistribution()

  if (!isHostRioCio && !isSubscriptionV4Enabled) {
    return <SubscriptionCancellationViewOld />
  }

  return (
    <>
      {isSubscriptionV4Enabled && step === 1 && (
        <SubscriptionCancellationViewStepOne
          onContinueCancellation={() => {
            if (!isRDSubCancellationTestEnabled || !canActivateRd) {
              setStep(3)
              return
            }

            if (hasResumeDistribution) {
              setStep(2.6)
            } else {
              setStep(2.7)
            }
          }}
        />
      )}
      {step === 2.6 && (
        <SubscriptionCancellationResumeDistribution onContinueCancellation={() => setStep(3)} />
      )}
      {step === 2.7 && (
        <SubscriptionCancellationResumeDistributionDisabled
          onContinueCancellation={() => setStep(3)}
        />
      )}
      {(!isSubscriptionV4Enabled || step === 3) && <SubscriptionCancellationViewStepThree />}
    </>
  )
}
